export default (text, index, element) =>
  Math.abs(index - text.indexOf(element, index)) <
  Math.abs(index - text.lastIndexOf(element, index))
    ? text.indexOf(element, index)
    : text.lastIndexOf(element, index);
